import React from 'react';
import { PageHeader } from '../../common/index';
import Statistics from './CitiesStatistics';
import ZonesTable from './ZonesTable';
import { useNavigationContext } from '../../context/NavigationContext';
import { getMyUserQuery } from '../../queries/queries';
import { useQuery } from '@apollo/client';

function Cities() {
  const { setNavigationActivated } = useNavigationContext();
  React.useEffect(() => {
    setNavigationActivated(true);
  }, []);

  const { data: userData, loading: userLoading, error: userError } = useQuery(getMyUserQuery);

  if (userLoading) return <div>Laddar...</div>;
  if (userError) return <div>Fel vid laddning av användardata</div>;

  const isSuperAdmin = userData?.user.superAdmin;
  const zoneIds = userData?.user?.adminObjects.zonesIAdmin.map(z => z._id);

  return (
    <div id="cities">
      <PageHeader>
        <h1>Administration</h1>

        <p><strong>Du är inloggad som {isSuperAdmin ? 'superadmin.' : 'zon-admin för följande zoner:'}</strong></p>
      </PageHeader>
      <Statistics superAdmin={isSuperAdmin} zoneIds={zoneIds} />
      <ZonesTable superAdmin={isSuperAdmin} zoneIds={zoneIds} />
    </div>
  );
}

export default Cities;
